import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Button, Modal, ModalActions, ModalContent } from '@uplift/ui-v2';

export type SubmitAndCancelUpcomingSessionsModalProps = {
  open: boolean;
  onClose: (proceed: boolean) => void;
};
export const SubmitAndCancelUpcomingSessionsModal: React.VFC<SubmitAndCancelUpcomingSessionsModalProps> = ({ open, onClose }) => {
  const { classes } = useSubmitAndCancelUpcomingSessionsModalStyles();

  const handleClose = () => {
    onClose(false);
  };

  const handleConfirm = () => {
    onClose(true);
  };

  return (
    <Modal
      open={open}
      maxWidth="md"
      fullWidth
      showCloseIcon
      title="Submit and cancel upcoming sessions"
      onClose={handleClose}
    >
      <ModalContent classes={{ root: classes.modalContent }}>
        <Typography>
          Submitting this discharge note will cancel all scheduled sessions with this client.
        </Typography>
      </ModalContent>
      <ModalActions>
        <Button color="secondary" variant="contained" onClick={handleConfirm}>Sign and submit</Button>
      </ModalActions>
    </Modal>
  );
};

const useSubmitAndCancelUpcomingSessionsModalStyles = makeStyles({ name: 'SubmitAndCancelUpcomingSessionsModal' })(theme => ({
  modalContent: {
    paddingBottom: theme.spacing(5)
  }
}));
